import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlantListInterface } from 'src/app/pages/record/interfaces';
import { environment } from 'src/environments/environment';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { ProjectSettingsService } from 'src/app/core/services/common/project-settings.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class PlantListCompanyStoreService {
  options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };

  constructor(
    private http: HttpClient,
    private settings: ProjectSettingsService,
    private cookieService: CookieService,
  ) {}

  getPlantListWithCompany(): Observable<PlantListInterface[]> {
    const userGuid = this.cookieService.get(environment.UserGuid).toUpperCase();
    const companyGuid = this.cookieService.get(environment.CompanyGuid).toUpperCase();
    const url = this.settings.generateEndpoint(
      EndpointConstants.ApiPlants + '?userGuid=' + userGuid + '&companyGuid=' + companyGuid,
    );
    return this.http.get<PlantListInterface[]>(url, this.options);
  }
}
